<template>
  <div class="home">
    <!-- <h2>这是home.vue页面</h2> -->
    <div id="MyViewerDiv" class="model"></div>
    <el-button class="modelButton" v-show="SJBool" size="small" @click="addLive">添加实景</el-button>
    <el-card class="box-card modelBottom" v-if="addLiveIsShow">
      <el-input v-model="addLiveList.mobl04" class="mar-top10" placeholder="名称"></el-input>
      <el-input v-model="addLiveList.mobl05" class="mar-top10" placeholder="地点"></el-input>
      <el-date-picker
        class="el-date-picker"
        v-model="addLiveList.mobl06"
        type="date"
        placeholder="拍摄时间"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-upload
        ref="AddLive"
        class="avatar-uploader"
        :action="addLiveActionUrl"
        :headers="importHeaders"
        :data="addLiveList"
        :auto-upload="false"
        :limit="1"
        :show-file-list="false"
        :on-change="addLiveHandleChange"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-button :loading="!buttonIsShow" @click="uploadAddLive" size="small">上传</el-button>
    </el-card>
  </div>
</template>

<script>
import {
  GetModelInfo,
  GetSelectOrView,
  GetMLableSetList,
  VerityViewPoint,
} from "@/setAxios";
export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      addLiveActionUrl: this.$store.state.baseUrl + "/api/UploadModelLable",
      importHeaders: { token: localStorage.getItem("token") },
      url: "",
      locationParams: {},
      addLiveIsShow: false,
      addLiveList: {
        mobl02: "",
        lbst03: 1,
        mobl03: "",
        mobl04: "",
        mobl05: "",
        mobl06: "",
        mobl07: 0,
        mobl09: "",
        mobl10: "",
        mobl11: "",
        mobl12: "",
        qid: "",
      },
      imageUrl: "",
      buttonIsShow: true,
      viewer: null,
      SJBool: false,
    };
  },
  props: ["selectId"],
  methods: {
    uploadAddLive() {
      const isNull =
        this.addLiveList.mobl04.trim().length > 0 &&
        this.addLiveList.mobl05.trim().length > 0 &&
        this.addLiveList.mobl06.trim().length > 0;
      if (isNull && this.imageUrl.length > 0) {
        this.$refs.AddLive.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请填写完整信息",
        });
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.Code == 1) {
        this.$message({
          type: "success",
          message: "上传成功",
        });

        this.addLiveIsShow = false;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    addLiveHandleChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("addLiveList", JSON.stringify(this.editModel));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png" || suffix === "jpg" || suffix === "bmp" || suffix === "tif" || suffix === "webp" || suffix === "jpeg"
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M
    },
    async addLive() {
      var select = this.viewer.getSelection(),
        _this = this;
      if (select.length > 0) {
        this.addLiveList.mobl10 = select[0];
        this.viewer.model.getData().instanceTree.enumNodeFragments(
          select[0],
          function (id) {
            _this.addLiveList.mobl11 = id;
          },
          false
        );
        var tmpState = this.viewer.getState();
        var jsonString = JSON.stringify(tmpState);
        this.addLiveList.mobl12 = jsonString.replace(/\"/g, "'");
      }
      if (this.locationParams.xid) {
        let params = {
          xid: this.locationParams.xid,
        };
        let res = await GetMLableSetList(params);
        let isImage = false;
        res.Data.forEach((ele) => {
          if (ele.lbst03 == 1) {
            this.addLiveList.mobl03 = ele.lbst01;
            isImage = true;
          }
        });
        if (isImage) {
          this.addLiveIsShow = !this.addLiveIsShow;
        } else {
          this.$message({
            type: "warning",
            message: "此项目未添加图片标签",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请重新添加条码",
        });
      }
    },
    viewers(url) {
      var Params = this.locationParams,
        _this = this;
      //初始化
      var config = {
        extensions: [
          "Autodesk.Viewing.ZoomWindow",
          // "Autodesk.Viewing.Collaboration",
        ],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
      };
      var myViewerDiv = document.getElementById("MyViewerDiv");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
        myViewerDiv,
        config
      );
      var options = {
        document: url,
        language: "zh-HANS",
        env: "Local",
        offline: "true",
        useADP: false,
      };
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        _this.viewer.start();
        _this.viewer.loadModel(options.document, {
          isAEC: true,
        });
        _this.viewer.setTheme("light-theme");
        _this.viewer.addEventListener(
          Autodesk.Viewing.TEXTURES_LOADED_EVENT,
          function (event) {
            if (Params.type == "property") {
              if (Params.xid) _this.SJBool = true;
              //构件属性
              _this.viewer.select(Number(Params.dbid));
              _this.viewer.fitToView([Params.dbid]);
              var interval = setInterval(() => {
                if ($("#ViewerPropertyPanel").length == 0) {
                  clearInterval(interval);
                  $(".adsk-icon-properties").click();
                }
              }, 1000);
            } else if (Params.type == "modelSelect") {
              //选择集
              var json = Params.state.replace(/'/g, '"');
              var jsonObject = JSON.parse(json);
              _this.viewer.restoreState(jsonObject);
            } else if (Params.type == "fxgj") {
              //分享构件
              _this.viewer.isolate(JSON.parse(Params.dbid));
              _this.viewer.select(JSON.parse(Params.dbid));
              _this.viewer.fitToView(JSON.parse(Params.dbid));
            } else if (Params.id) {
              //分享视点
              let params = { id: Params.id, type: 3 };
              if (Params.type == "fxsd") {
                params = { id: Params.id, type: 3, from: "fxsd" };
              }
              GetSelectOrView(params).then((res) => {
                if (res.Data.markup == null) return;
                var json = res.Data.state.replace(/'/g, '"');
                var jsonObject = JSON.parse(json);
                if (_this.viewer.restoreState(jsonObject)) {
                  _this.viewer
                    .loadExtension("Autodesk.Viewing.MarkupsCore")
                    .then((markupM) => {
                      markupM.load();
                      // markupM.enterEditMode();
                      var markup = res.Data.markup;
                      setTimeout(() => {
                        markupM.show();
                        if (
                          markup &&
                          markup.replace(/(^\s*)|(\s*$)/g, "").length > 0
                        ) {
                          var markupList = markup.split("@#@");
                          if (markupList != null && markupList.length > 0) {
                            for (var i = 0, l = markupList.length; i < l; i++) {
                              var singleMarkup = markupList[i].split("@BIM@");
                              markupM.loadMarkups(
                                singleMarkup[1].replace(/'/g, '"'),
                                singleMarkup[0]
                              );
                            }
                          }
                        }
                      }, 500);
                    });
                }
              });
            }
          }
        );
      });
    },
  },
  created() {
    var _this = this;
    var search = window.location.hash
      .substr(1)
      .split("=")[1]
      .replace(/%3D/g, "=");
    search = Base64.decode(search).split("^@^");
    search.forEach((str) => {
      let name = str.slice(0, str.indexOf("="));
      let val = str.slice(str.indexOf("=") + 1);
      _this.locationParams[name] = val;
    });
    _this.addLiveList = {
      mobl02: _this.locationParams.xid,
      lbst03: 1,
      mobl03: "",
      mobl04: "",
      mobl05: "",
      mobl06: "",
      mobl07: 0,
      mobl09: _this.locationParams.modelId,
      mobl10: _this.locationParams.dbid,
      mobl11: "",
      mobl12: "",
      qid: _this.locationParams.qid,
    };
  },
  async mounted() {
    if (this.locationParams.type == "fxsd") {
      let res = await VerityViewPoint({
        params: { id: this.locationParams.id },
      });
      if (res.Code == 0) {
        this.$message({
          showClose: true,
          message: res.Message,
          type: "error",
          duration: 0,
        });
        return;
      }
    }

    let params = {
      modelId: this.locationParams.modelId,
      mtype:
        this.locationParams.mtype == undefined ? "" : this.locationParams.mtype,
    };
    GetModelInfo(params).then((res) => {
      if (res.Code != 1) {
        this.$message({
          type: "warning",
          message: res.Message,
        });
        return;
      }
      //(this.locationParams.modelId);
      if (localStorage.token !== undefined) {
        EaBIM.modelData.modelId = this.locationParams.modelId;
      }
      this.viewers(this.$store.state.baseUrl + res.Data.mode09);
    });
  },
};
</script>

<style lang="less" scoped>
@import url("../../public/Content/css/style.css");
.model {
  position: fixed;
  width: 100%;
  height: 100%;
}
.modelBottom {
  position: fixed;
  width: 50%;
  top: 6%;
  left: 2%;
  z-index: 99;
}
.modelButton {
  position: fixed;
  left: 2%;
  z-index: 9999;
}
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
//新增
.mar-top10 {
  margin-top: 10px;
}
.el-date-picker {
  width: 100%;
  margin-top: 10px;
  z-index: 9999;
}
</style>
